import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  search: {
    width: '90%',
    maxWidth: '900px',
    margin: '50px 0',
  },
});
